module.exports = __webpack_public_path__ + "img/tarot-major-arcana-08.768e0f24.png";